var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9238 1.92476L9.42383 9.42476C9.31931 9.52964 9.19512 9.61286 9.05837 9.66964C8.92163 9.72642 8.77502 9.75565 8.62695 9.75565C8.47889 9.75565 8.33228 9.72642 8.19553 9.66964C8.05878 9.61286 7.93459 9.52964 7.83008 9.42476L0.330077 1.92476C0.118732 1.71342 -3.14928e-09 1.42677 0 1.12789C3.14928e-09 0.829003 0.118732 0.542358 0.330077 0.331014C0.541421 0.11967 0.828065 0.000937703 1.12695 0.0009377C1.42584 0.000937697 1.71248 0.11967 1.92383 0.331014L8.62789 7.03508L15.332 0.330077C15.5433 0.118733 15.8299 0 16.1288 0C16.4277 0 16.7144 0.118733 16.9257 0.330077C17.137 0.541421 17.2558 0.828066 17.2558 1.12695C17.2558 1.42584 17.137 1.71248 16.9257 1.92383L16.9238 1.92476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenu);
export default __webpack_public_path__ + "static/media/arrow-menu.aa02b37192ff4e7d1cdfa963fd4ce3c9.svg";
export { ForwardRef as ReactComponent };